/* eslint-disable @next/next/no-img-element */
//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import { useSelector, useDispatch } from "react-redux";
import { useState, useCallback, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Col, Row, Space, Avatar, Typography } from "antd";

//? Assets --------------------------------------------------------------------->
import Coins from "../../../assets/images/AccountsPage/CoinsStack.svg";
import RewardPoints from "../../../assets/images/AccountsPage/RewardPoints.svg";

import InProcess from "../../../assets/images/AccountsPage/InProcess.svg";

import order_pending from "../../../assets/images/AccountsPage/order_pending.svg";
import order_cancelled from "../../../assets/images/AccountsPage/order_cancelled.svg";
import order_delivered from "../../../assets/images/AccountsPage/oder_delivered.svg";

//? Modules -------------------------------------------------------------------->
import "./DashboardModule.css";
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
import TrackOrderModal from "@/components/Homepage/TrackOrderModal/TrackOrderModal";
//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
const defaultImage = "https://rb.gy/wi9shp";

export default function DashboardModule({ userAgent, setActiveMenu }) {
  const { isDesktop } = userAgent;
  const { comverse_customer_token } = AccountStatus();

  //? Redux States --------------------------------------------------------------->
  const defaultCurrency = useSelector(
    (state) => state?.multiLocation?.defaultCurrency
  );

  //? States --------------------------------------------------------------------->
  const dispatch = useDispatch();

  const [DashboardDetails, setDashboardDetails] = useState({});
  const [OpenOrderTrackingModal, setOpenOrderTrackingModal] = useState(false);
  const router = useRouter();

  //? Functions ------------------------------------------------------------------>
  const fetchDashboardDetails = useCallback(async () => {
    if (comverse_customer_token) {
      try {
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "GET",
          headers: headers,
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + "/storefront/customer_dashboard",
          payload
        );

        const data = await res.json();

        if (!res.ok) {
          if (data?.detail === "Invalid auth token") {
            customerLogout();
            dispatch(logoutReducer());
            router.push("/login");
          }
          //logout here
          throw new Error("Api Failed!");
        }

        setDashboardDetails(data);
        return data;
      } catch (error) {
        console.error("Error fetching data:", error.message);
        return null;
      }
    }
  }, [comverse_customer_token]);

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    if (comverse_customer_token) {
      fetchDashboardDetails();
    }
  }, [comverse_customer_token, fetchDashboardDetails]);

  return (
    <Col className="DashboardModule padding20">
      <Space
        className={
          isDesktop
            ? "width100 flexBetween marginBottom15"
            : "width100 flexBetween padding10"
        }
      >
        <Text className={isDesktop ? "font18" : "font14"}>My Dashboard</Text>
      </Space>

      <Row className="gap2000" justify="space-between">
        <Col flex="66.8%" className="ordersListing">
          <Col span={24} className={isDesktop ? "" : "padding10"}>
            <Row justify="space-between" className="width100">
              <Col
                flex={isDesktop ? "0 0 49%" : "0 0 48.5%"}
                // sm={{ span: 12 }}
                className="rewardCard flexCenter"
              >
                <Space className="flexBetween width100">
                  <Space direction="vertical">
                    <Text className={isDesktop ? "font18" : "font14"}>
                      Reward Points
                    </Text>
                    <Text className={isDesktop ? "font26Bold" : "font16Bold"}>
                      {DashboardDetails?.loyalty_points
                        ? DashboardDetails?.loyalty_points
                        : 0}
                      &nbsp;Points
                    </Text>
                    <Text
                      className="font10Bold poppinsSemiBold"
                      style={{ color: "#B7B7B7" }}
                    >
                      Balance
                    </Text>
                  </Space>
                  <Space direction="vertical" align="center">
                    <Image
                      src={RewardPoints}
                      // width="100%"
                      // height="auto"
                      width={isDesktop ? "63px" : "45px"}
                      height={isDesktop ? "81px" : "auto"}
                      alt="Reward Points"
                      preview={false}
                    />
                    <Text className="font10Bold">
                      1 Point = 1 {defaultCurrency}
                    </Text>
                  </Space>
                </Space>
              </Col>

              <Col
                flex={isDesktop ? "0 0 49%" : "0 0 48.5%"}
                // sm={{ span: 12 }}
                className="walletCard flexCenter"
              >
                <Space className="flexBetween width100">
                  <Space direction="vertical">
                    <Text className={isDesktop ? "font18" : "font14"}>
                      My Wallet
                    </Text>
                    <Text className={isDesktop ? "font26Bold" : "font16Bold"}>
                      {DashboardDetails?.wallet_points
                        ? DashboardDetails?.wallet_points
                        : 0}
                      &nbsp;PKR
                    </Text>
                    <Text
                      className="font10Bold poppinsSemiBold"
                      style={{ color: "#B7B7B7" }}
                    >
                      Balance
                    </Text>
                  </Space>
                  <Space direction="vertical">
                    <Image
                      src={Coins}
                      // width="100%"
                      // height="auto"
                      width={isDesktop ? "73" : "45px"}
                      height={isDesktop ? "75px" : "auto"}
                      alt="Wallet Points"
                      preview={false}
                    />
                  </Space>
                </Space>
              </Col>
            </Row>
          </Col>

          <Col
            span={24}
            className={
              isDesktop
                ? "ordersHistory marginTop20 padding15"
                : "ordersHistory marginTop20"
            }
          >
            {isDesktop ? (
              <Col span={24}>
                <Col span={24} className="marginBottom15">
                  <Space className="flexBetween">
                    <Text className="font16Bold">My Orders </Text>
                  </Space>
                </Col>

                <Col span={24}>
                  <Col span={24}>
                    {DashboardDetails?.orders?.length > 0 &&
                      DashboardDetails?.orders?.map((order, index) => {
                        return (
                          <Col span={24} key={index}>
                            <Row
                              align="center"
                              justify="space-between"
                              className="padding10 borderTop borderBottom"
                            >
                              <Space>
                                <Col className="flexCenter">
                                  <Text
                                    className="flexCenter"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      fontSize: "11px",
                                      color: "#B7B7B7",
                                      background:
                                        "#F2F3F7 0% 0% no-repeat padding-box",
                                    }}
                                  >
                                    {index + 1}
                                  </Text>
                                </Col>

                                <Col
                                  className="alignCenter ProductCount"
                                  style={{ overflow: "hidden" }}
                                >
                                  <Row style={{ minHeight: "82px" }}>
                                    <div
                                      className=""
                                      style={{
                                        position: "relative",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        width: "82px",
                                        height: "82px",
                                      }}
                                    >
                                      {order?.images?.length > 1 ? (
                                        order?.images?.map(
                                          (image, index) =>
                                            index <= 3 && (
                                              <div
                                                key={index}
                                                style={{
                                                  position: "relative",
                                                  flexBasis: "50%",
                                                  height: "41px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  marginBottom: "2px",
                                                }}
                                                className={
                                                  index === 3 &&
                                                  "img_mask ImageCount"
                                                }
                                              >
                                                {image ? (
                                                  <img
                                                    // width={41}
                                                    height={41}
                                                    src={image}
                                                    alt="Product Image"
                                                    className="img_mask"
                                                  />
                                                ) : (
                                                  <div
                                                    style={{
                                                      backgroundColor:
                                                        "#F5F5F5",
                                                      height: "41px",
                                                      width: "41px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <Text
                                                      style={{
                                                        textAlign: "center",
                                                        fontSize: "9px",
                                                        alignSelf: "center",
                                                      }}
                                                    >
                                                      No Image
                                                    </Text>
                                                  </div>
                                                )}

                                                {index === 3 &&
                                                  order?.images?.length - 4 >
                                                    0 && (
                                                    <Text
                                                      className={
                                                        isDesktop
                                                          ? "img_mask_tag"
                                                          : "img_mask_tag img_mask_tag_mobile"
                                                      }
                                                    >
                                                      +
                                                      {order?.images?.length -
                                                        4}
                                                    </Text>
                                                  )}
                                              </div>
                                            )
                                        )
                                      ) : (
                                        <div
                                          key={index}
                                          style={{
                                            position: "relative",
                                            flexBasis: "100%",
                                            height: "82px",
                                            justifyContent: "center",
                                            display: "flex",
                                            // width: "82px",
                                          }}
                                        >
                                          <img
                                            // width={82}
                                            height={82}
                                            src={order?.images[0]}
                                            alt="Default Product Image"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Row>
                                </Col>
                              </Space>

                              <Col className="alignCenter" span={8}>
                                <Space direction="vertical" className="gap5">
                                  <Text className="font14Bold">
                                    Order Number :&nbsp;
                                    {order?.name ? order?.name : "N/A"}
                                  </Text>
                                  <Text className="font14">
                                    Amount : {order?.currency}&nbsp;
                                    {order?.total_price
                                      ? order?.total_price
                                      : "N/A"}
                                  </Text>
                                  <Text className="font14">
                                    Qty: &nbsp;
                                    {order?.total_quantity
                                      ? order?.total_quantity
                                      : "N/A"}
                                  </Text>
                                </Space>
                              </Col>

                              <Col
                                className="alignCenter"
                                style={{
                                  width: "12%",
                                  justifyContent: "center",
                                }}
                              >
                                {order?.order_status !== "Delivered" &&
                                order?.order_status !== "Cancelled" &&
                                order?.order_status !== "Returned" ? (
                                  <Text className="font12">
                                    Shipment by {order?.shipping_date}
                                  </Text>
                                ) : (
                                  <Text className="font12">NA</Text>
                                )}
                              </Col>

                              <Col className="alignCenter">
                                <Image
                                  // style={{ display: "none" }}
                                  src={
                                    (order?.order_status === "Dispatched" &&
                                      order_pending) ||
                                    (order?.order_status === "Pending" &&
                                      order_pending) ||
                                    (order?.order_status === "Cancelled" &&
                                      order_cancelled) ||
                                    (order?.order_status === "Returned" &&
                                      order_cancelled) ||
                                    (order?.order_status === "Delivered" &&
                                      order_delivered)
                                  }
                                  alt={
                                    order?.order_status === "created"
                                      ? "InProcess"
                                      : "InProcess"
                                  }
                                  width={24}
                                  height={24}
                                />
                              </Col>

                              <Col className="alignCenter">
                                {/* <a
                                  target="_blank"
                                  // href="#"
                                  href={`https://oms.alfamall.com/ordertracking/021024025744950817?contact=${order?.phone}&name=${order?.name}`}
                                >
                                  <Text
                                    className="font10Bold"
                                    style={{
                                      color: "#5A7184",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Track Order
                                  </Text>
                                </a> */}
                                <button
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "center",
                                    display: "flex",
                                    background: "none",
                                  }}
                                  className="font10Bold"
                                  onClick={() =>
                                    setOpenOrderTrackingModal(true)
                                  }
                                >
                                  <Text className="font10Bold"
                                    style={{
                                      color: "#5A7184",
                                      textDecoration: "underline",
                                    }}>
                                  Track Order
                                  </Text>
                                </button>
                              </Col>
                            </Row>
                          </Col>
                        );
                      })}
                  </Col>
                  {
                    <Col span={24}>
                      {DashboardDetails?.orders?.length === 0 && (
                        <Typography className="no-order-found-text">
                          No Orders Found
                        </Typography>
                      )}
                    </Col>
                  }
                </Col>
              </Col>
            ) : (
              <Col>
                {DashboardDetails?.orders?.map((order, index) => {
                  return (
                    <Col
                      key={index}
                      className="OrderCard backgroundColor padding10 marginBottom10"
                    >
                      <Space
                        className="row"
                        style={{
                          width: "100%",
                          alignItems: "start",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Avatar
                          shape="square"
                          size="small"
                          className="borderRadius0"
                          icon={<Text>{index + 1}</Text>}
                        />
                      </Space>

                      <Row
                        className="row"
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col span={8} style={{ overflow: "hidden" }}>
                          <Image
                            width={100}
                            alt="Product"
                            height={100}
                            src=""
                            preview={false}
                          />
                        </Col>

                        <Col span={15}>
                          <Space direction="vertical">
                            <Text className="font14Bold">
                              Order Number :{order?.name ? order?.name : "N/A"}
                            </Text>
                            <Text className="font14">
                              <Text>Amount : {defaultCurrency}&nbsp;</Text>
                              {order?.total_price ? order?.total_price : "N/A"}
                            </Text>
                            <Text>
                              <Text className="font14">Qty: </Text>
                              {order?.quantity ? order?.quantity : "N/A"}
                            </Text>
                          </Space>
                        </Col>
                      </Row>

                      <Row
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          marginTop: "15px",
                        }}
                      >
                        {/* <Col flex="48%">
                          <DynamicButton name="Cancel Order" />
                        </Col> */}
                        <Col flex="48%">
                          {/* <a
                            target="_blank"
                            // href="#"
                            href={`https://oms.alfamall.com/ordertracking/021024025744950817?contact=${order?.customer_data?.phone}&name=${order?.name}`}
                          >
                            <DynamicButton name="Track Order" />
                          </a> */}
                          <button
                            style={{
                              cursor: "pointer",
                              alignItems: "center",
                              display: "flex",
                              background: "none",
                              padding: 0,
                              margin: 0,
                              color: "#5A7184",
                              textDecoration: "underline",
                            }}
                            className="font10Bold"
                            onClick={() => setOpenOrderTrackingModal(true)}
                          >
                            Track Order
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  );
                })}
              </Col>
            )}
          </Col>
        </Col>

        <Col flex="28%" className="customerHistory">
          <Col className="infoCard">
            <Col>
              <Space className="flexBetween">
                <Text className="font14Bold">Personal Info</Text>
                <DynamicButton
                  name="Edit"
                  function={() => setActiveMenu("edit")}
                  style={{ border: "none", color: "#5A7184", fontSize: "11px" }}
                />
              </Space>
            </Col>

            <Col
              style={{
                padding: "5px 0px",
                borderTop: "1px solid #E2E5F1",
                borderBottom: "1px solid #E2E5F1",
              }}
            >
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Name:&nbsp;
                {DashboardDetails?.profile?.full_name
                  ? DashboardDetails?.profile?.full_name
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Email:&nbsp;
                {DashboardDetails?.profile?.email
                  ? DashboardDetails?.profile?.email
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Mobile Number:&nbsp;
                {DashboardDetails?.profile?.phone
                  ? DashboardDetails?.profile?.phone
                  : "N/A"}
              </Text>
              <br />
              <Text className="font12" style={{ color: "#7A7A7A" }}>
                Gender:&nbsp;
                {DashboardDetails?.profile?.gender
                  ? DashboardDetails?.profile?.gender
                  : "N/A"}
              </Text>
            </Col>

            {/* <Col>
              <Text className="font12 marginTop5">
                Unsubscribed to newsletter &nbsp;
                <span
                  style={{ color: "#FF3F6C", textDecoration: "underline" }}
                  className="font12Bold"
                >
                  SUBSCRIBE
                </span>
              </Text>
            </Col> */}
          </Col>
        </Col>
      </Row>
      {OpenOrderTrackingModal && (
        <TrackOrderModal
          showTrackOrderModal={setOpenOrderTrackingModal}
          openTrackOrderModal={OpenOrderTrackingModal}
        />
      )}
    </Col>
  );
}
